import { Button } from "components/Button";
import React from "react";
import { useBettingFilters } from "../hooks/useBettingFilters";

export const BettingEmptyStateActions = () => {
  const [filters, setFilters] = useBettingFilters();

  const isSportsHub = filters.hub === "sports";

  if (filters.sgm === "true") {
    return (
      <Button
        size="sm"
        onClick={() => {
          setFilters({ sgm: undefined });
        }}
      >
        Remove SGM Filter
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      onClick={() => {
        setFilters({
          sports: undefined,
          hub: isSportsHub ? "sports" : undefined,
          sport: undefined,
        });
      }}
    >
      View All {isSportsHub ? "Sports" : "Esports"}
    </Button>
  );
};
